<template>
  <div class="third">
    <div style="margin-bottom: 10px">
      <!-- <ZTB /> -->
    </div>
    <div style="position: relative" v-if="!cityDetail.changeJRFWtoCaodi">
      <img
        src="@/assets/img/caodi3.png"
        style="width: 100%; height: 155px"
        alt=""
      />
    </div>
    <div
      class="jrfw"
      v-if="
        cityDetail.changeJRFWtoCaodi &&
        !cityDetail.notHaveJRFW &&
        cityDetail.cityName != '获嘉县'
      "
      @click="goJRFWInfo"
      :style="{ cursor: cityDetail.goJRFWInfo ? 'pointer' : 'auto' }"
    >
      <div>
        <span>金融服务</span>
        <span>一站式金融服务平台</span>
      </div>
    </div>
    <div
      v-if="
        cityDetail.changeJRFWtoCaodi &&
        !cityDetail.notHaveJRFW &&
        cityDetail.cityName == '获嘉县'
      "
      class="hjx_jrfw"
    >
      <div class="mode_title">
        <span>金融服务</span>
      </div>
      <div class="mode_content">
        <div class="mode_left">
          <img src="@/assets/金融服务/获嘉首页金融服务.png" alt="" />
          <div class="bankList">
            <div class="bank" v-for="(bank, index) in bankList" :key="index">
              <img :src="bank.img" alt="" />
            </div>
          </div>
        </div>
        <div class="mode_right">
          <div
            class="financial"
            v-for="(financial, index) in financialList"
            :key="index"
          >
            <div class="logo">
              <img :src="financial.img" alt="" />
            </div>
            <div class="financial_detail">
              <div class="title">{{ financial.title }}</div>
              <div class="financial_content">
                <div class="financial_options">
                  <span class="rate_text">{{ financial.rate }}</span>
                  <span class="financial_option_title">贷款利率</span>
                </div>
                <div class="financial_options">
                  <span class="deadline_text">{{ financial.deadline }}</span>
                  <span class="financial_option_title">贷款期限</span>
                </div>
                <div class="financial_options">
                  <span class="limit_text">{{ financial.limit }}</span>
                  <span class="financial_option_title">贷款额度</span>
                </div>
              </div>
            </div>
            <div class="financial_btn">
              <div @click="goDetail(financial)"><span>详情介绍</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 项目查询 -->
    <div style="margin-bottom: 10px">
      <JJXM></JJXM>
    </div>
    <YXIMG></YXIMG>
    <PYSYXZCSR v-if="cityDetail.cityName == '濮阳市'" />
    <div
      class="jrfw"
      v-if="!cityDetail.notHaveJRFW && !cityDetail.changeJRFWtoCaodi"
      @click="goJRFWInfo"
      :style="{ cursor: cityDetail.goJRFWInfo ? 'pointer' : 'auto' }"
    >
      <div>
        <span>金融服务</span>
        <span>一站式金融服务平台</span>
      </div>
    </div>
    <div style="position: relative" v-if="cityDetail.changeJRFWtoCaodi">
      <img
        src="@/assets/img/caodi3.png"
        style="width: 100%; height: 155px"
        alt=""
      />
    </div>
    <YQLJ v-if="cityDetail.showPYSYQLJ" />
    <div></div>
  </div>
</template>

<script>
import JJXM from './Third/竞价项目.vue'
import ZTB from './Third/招投标.vue'
import TDXX from './Third/土地信息.vue'
import TDZCJYTDZSXX from './Third/政策交易土地招商.vue'
import JRFW from './Third/金融服务.vue'
import XMCX from './Third/项目查询.vue'
import YXZC from './Third/意向转出.vue'
import YXSR from './Third/意向受让.vue'
import RZCX from './Third/融资查询.vue'
import ZLXZ from './Third/资料下载.vue'
import GGL from './Third/公告栏.vue'
import YXIMG from './Third/意向转出受让鉴证书图片.vue'
import YX from './Third/意向转出受让.vue'
import PYSYXZCSR from './Third/意向转出受让_濮阳市.vue'
import GSGG from './First/公示公告.vue'
import YQLJ from './Third/友情链接2.vue'
import { cityDetail } from '../../util/mainOption'

export default {
  data () {
    return {
      bankList: [
        {
          title: "中国农业银行",
          img: require("../../assets/金融服务/中国农业银行.png"),
        },
        {
          title: "河南农商银行",
          img: require("../../assets/金融服务/河南农商银行.png"),
        },
        // {
        //   title: "中国工商银行",
        //   img: require("../../assets/金融服务/中国工商银行.png"),
        // },
        // {
        //   title: "中国建设银行",
        //   img: require("../../assets/金融服务/中国建设银行.png"),
        // },
        // {
        //   title: "中国银行",
        //   img: require("../../assets/金融服务/中国银行.png"),
        // },
        // {
        //   title: "中原银行",
        //   img: require("../../assets/金融服务/中原银行.png"),
        // },
      ],
      financialList: [
        {
          img: require("../../assets/金融服务/中国农业银行_金融服务列表.png"),
          title: "惠农e贷",
          rate: "2.5‰起",
          deadline: "1-36个月",
          limit: "1-50万元",
          path: "/zgnyyhInfoHJX",
        },
        {
          img: require("../../assets/金融服务/河南农商银行_金融服务列表.png"),
          title: "惠农贷款",
          rate: "2.75‰起",
          deadline: "1-36个月",
          limit: "1-1000万元",
          path: "/hnnsyhInfoHJX",
        },
        // {
        //   img: require("../../assets/金融服务/中国工商银行_金融服务列表.png"),
        //   title: "工商银行养殖e贷",
        //   rate: "3.85‰-5.39‰",
        //   deadline: "1-96个月",
        //   limit: "1-1000万元",
        // },
        // {
        //   img: require("../../assets/金融服务/中国建设银行_金融服务列表.png"),
        //   title: "建设银行裕农快贷",
        //   rate: "3.85‰-5.39‰",
        //   deadline: "1-96个月",
        //   limit: "1-1000万元",
        // },
        // {
        //   img: require("../../assets/金融服务/中国银行_金融服务列表.png"),
        //   title: "中国银行·益农贷",
        //   rate: "3.85‰-5.39‰",
        //   deadline: "1-96个月",
        //   limit: "1-1000万元",
        // },
        // {
        //   img: require("../../assets/金融服务/中原银行_金融服务列表.png"),
        //   title: "乡村振兴产业普惠贷款",
        //   rate: "3.85‰-5.39‰",
        //   deadline: "1-96个月",
        //   limit: "1-1000万元",
        // },
      ]
    }
  },
  components: {
    JJXM,
    TDXX,
    TDZCJYTDZSXX,
    JRFW,
    XMCX,
    YXZC,
    YXSR,
    RZCX,
    ZLXZ,
    GGL,
    YXIMG,
    YX,
    GSGG,
    ZTB,
    YQLJ,
    PYSYXZCSR,
  },
  created () { },
  mounted () { },
  computed: {},
  watch: {},
  methods: {
    goDetail (financial) {
      if (financial.path) {
        this.$router.push({
          path: financial.path,
        })
      }
    },
    goJRFWInfo () {
      if (cityDetail.goJRFWInfo && cityDetail.cityName == "信阳市") {
        this.$router.push({
          path: '/jrfwListXXS',
        })
      }
    }
  },
}
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
.imageSpan {
  font-size: 28px;
  position: absolute;
  white-space: nowrap;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -70%);
  color: white;
  font-weight: 550;
}
.jrfw {
  background: url("../../assets/img/jrfw.png") no-repeat;
  background-size: 100% 100%;
  height: 300px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.jrfw > div {
  display: flex;
  align-items: center;
}
.jrfw > div > span:first-child {
  font-size: 70px;
  color: #fff;
  font-weight: bold;
  letter-spacing: 10px;
  text-shadow: 0px 7px 5px rgba(133, 133, 133, 1),
    0px 8px 5px rgba(133, 133, 133, 1), 0px 13px 6px rgba(0, 0, 0, 0.3),
    0px 14px 6px rgba(0, 0, 0, 0.3), 0px 15px 6px rgba(0, 0, 0, 0.3);
}
.jrfw > div > span:last-child {
  font-size: 70px;
  color: #fff;
  letter-spacing: 4px;
}
.hjx_jrfw {
  background-color: #fff;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1);
  margin-bottom: 15px;

  .mode_title {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    padding: 0 61px 0 37px;
    /* width: 1174px; */
    height: 80px;
    color: #2187ff;
    border-bottom: 1px solid #2187ff;
    & > span {
      display: block;
      width: auto;
      height: 50px;
      font-size: 37px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #2187ff;
      padding-left: 5px;
      border-left: #2187ff 6px solid;
      line-height: 50px;
    }
  }

  .mode_content {
    padding: 30px 0;
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    height: auto;
    .mode_left {
      display: flex;
      flex-flow: column nowrap;
      flex: 1;
      margin-right: 30px;
      .bankList {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-row-gap: 30px;
        grid-column-gap: 30px;
        background-color: #e2bc75;
        width: 100%;
        height: auto;
        padding: 50px 30px;
        .bank {
          width: 100%;
          height: auto;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
      }
    }
    .mode_right {
      flex: 2;
      display: flex;
      flex-flow: column nowrap;
      .financial {
        display: flex;
        align-items: center;
        flex-flow: row nowrap;
        width: 100%;
        box-shadow: 0px 0px 12px 0px rgba(21, 21, 21, 0.1);
        padding: 68px 40px;
        transition: all 0.3s;
        margin-bottom: 40px;
        &:last-child {
          margin-bottom: 0;
        }
        &:hover {
          box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.2);
        }
        .logo {
          position: relative;
          width: 240px;
          height: auto;
          margin-right: 50px;
          padding-right: 40px;
          &::after {
            content: "";
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 1px;
            height: 200px;
            background-color: #ddd;
          }
          img {
            display: block;
            height: auto;
            width: 100%;
          }
        }
        .financial_detail {
          display: flex;
          flex-flow: column nowrap;
          align-items: start;
          flex: 1;
          .title {
            font-size: 34px;
            font-weight: bold;
            margin-bottom: 20px;
          }
          .financial_content {
            display: flex;
            flex-flow: row nowrap;
            .financial_options {
              display: flex;
              flex-flow: column nowrap;
              margin-right: 44px;
              .rate_text {
                color: #0bcd6b;
                font-size: 34px;
                font-weight: bold;
              }
              .deadline_text {
                font-size: 34px;
                color: #333;
                font-weight: 550;
              }
              .limit_text {
                font-size: 34px;
                color: #333;
                font-weight: bold;
              }
              .financial_option_title {
                color: #8c8c8c;
                font-size: 30px;
                margin-top: 10px;
              }
            }
          }
        }
        .financial_btn {
          width: auto;
          div {
            text-align: center;
            width: 150px;
            height: 60px;
            line-height: 60px;
            background-color: #e6a23c;
            border-radius: 4px;
            cursor: pointer;
            transition: all 0.3s;
            span {
              color: #fff;
              font-size: 24px;
            }
            &:hover {
              opacity: 0.8;
            }
          }
        }
      }
    }
  }
}
</style>
